<template>
  <div>
    <StatusMessage ref="status" />
    <div v-if="plans">
      <div class="text-center" v-if="plans.length > 0">{{ $t.get('Hvilken hastighet ønsker du?') }}</div>
      <div class="alert alert-warning text-center" v-if="plans.length === 0">
        Av ukjente årsaker klarte vi ikke å hente opp en liste over produkter og tjenester tilgjengelig på adressen din. Send oss en melding via nettsiden eller ring oss, så sjekker vi adressen din manuelt.
      </div>
      <div class="plan" v-for="plan of plans" :key="plan.id">
        <div class="product" v-for="product of plan.products" :key="product.id" v-on:click.prevent="selectProduct(product)">
          <div>
            <div class="left">
              <div class="large">{{ product.title }}</div>
            </div>
            <div class="right">
              <div class="large">{{ getProductPrice(product) }} <span class="small"><span v-if="!hasDecimalPlace(getProductPrice(product))">.-</span>/{{ formatBillingPeriod(product.billing_period) }}</span></div>
            </div>
          </div>

          <div>
            <div class="left"><div class="points"><div class="medium" v-if="product.speed_down">{{ formatAsMb(product.speed_down, product.speed_unit) }} Mbit hastighet inn</div><div class="medium" v-if="product.speed_up">{{ formatAsMb(product.speed_up, product.speed_unit) }} Mbit hastighet ut</div><div class="medium" v-for="(point, index) of product.additional_points" :key="'ap-' + index">{{ point }}</div></div></div>
            <div class="right">
              <div class="medium" v-if="product.establishment">{{ $t.get('Etablering') }}: {{ getProductEstablishment(product) }}<span v-if="!hasDecimalPlace(getProductEstablishment(product))">.-</span></div>
              <div class="small" v-if="product.billing_period === 'M'">{{ $t.get('Årspris') }} {{ calcYearlyPrice(getProductPrice(product)) }}<span v-if="!hasDecimalPlace(calcYearlyPrice(getProductPrice(product)))">.-</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.product {
  background: #fff;
  color: #000;
  padding: 8px;
  box-sizing: border-box;
  margin-bottom: 8px;
  cursor: pointer;
  transition: 0.25s all;
}
.product > div {
  display: flex;
  align-items: center;
}
.product:hover {
  background: #000;
  color: #fff;
}
.product .large {
  font-weight: bold;
}
.product .left {
  box-sizing: border-box;
  width: 60%;
  padding: 4px;
  word-break: break-word;
}
.product .right {
  box-sizing: border-box;
  width: 40%;
  padding: 4px;
}
.product .small {
  color: #000;
  font-weight: normal;
}
.product:hover .small {
  color: #fff;
}
.product .points > div {
  display: inline-block;
  width: 50%;
}
.product .large {
  font-size: 20px;
}
.product .medium {
  font-size: 15px;
}
.product .small {
  font-size: 15px;
}
@media (min-width: 576px) {
  .product .left {
    width: calc(100% - 200px);
  }
  .product .right {
    width: 200px;
  }
  .product .large {
    font-size: 30px;
  }
  .product .medium {
    font-size: 16px;
  }
  .product .small {
    font-size: 16px;
  }
}
</style>

<script>
/* global Urls */
import StatusMessage from '@/components/StatusMessage.vue';

export default {
  components: {
    StatusMessage
  },
  props: ['addressId', 'serviceType', 'session'],
  data() {
    return {
      plans: null,
      billingPeriodLabels: {
        'M': this.$t.get('mnd'),
        'Y': this.$t.get('år')
      },
    };
  },
  mounted() {
    this.updateProducts()
  },
  methods: {
    updateProducts() {
      this.$refs.status.clear();

      this.$ajax.post(Urls.order_address_plans(this.addressId), {
        service_type: this.serviceType,
        session: this.session
      }, true).then((res) => {
        this.plans = res.results;
      }).catch((err) => {
        console.error(err);
        this.$refs.status.error(this.$t.get('Det oppsto en feil i bestillingssystemet.') + ' ' + this.$t.get('Vent et øyeblikk og klikk her for å prøve igjen.'), () => {
          this.updateProducts();
        });
      });
    },
    formatBillingPeriod(period) {
      return this.billingPeriodLabels[period] ? this.billingPeriodLabels[period] : '';
    },
    calcYearlyPrice(price) {
      return price * 12;
    },
    selectProduct(product) {
      if (product.order_url) {
        window.location.href = product.order_url + '?address_id=' + this.addressId;
      } else {
        window.location.href = Urls.order_app(product.id, this.addressId);
      }
    },
    getProductPrice(product) {
      return product.show_with_vat && product.price_with_vat ? product.price_with_vat : product.price;
    },
    getProductEstablishment(product) {
      return product.show_with_vat && product.establishment_with_vat ? product.establishment_with_vat : product.establishment;
    },
    hasDecimalPlace(val) {
      return val % 1 != 0;
    },
    formatAsMb(speed, unit) {
      if (unit === 'Gb') {
        return parseInt(speed) * 1000;
      }
      if (unit === 'Kb') {
        return parseInt(speed) / 1000;
      }
      return speed;
    }
  },
  watch: {
    addressId() {
      this.updateProducts()
    }
  }
}
</script>